export default {
  allStyles: 'All styles by linesheet',
  selectEvent: 'Search for an event',
  selectLinesheet: 'Search for a linesheet',
  selectOne: 'Select one',
  selectRetailer: 'Search for a retailer',
  startOrder: 'Start an Order',
  startTyping: 'Start typing to search...',
}
